import {ControlDelivery} from "../../../../types/delivery/control-delivery";
import {DeliveryGroupType} from "../../../../types/schedule/delivery-group-type";
import {
    findIndexByBiggerDropOffTimeLimited,
    findIndexByBiggerPickUpTimeLimited,
    findLastIndexBySameDropOffTimeLimited,
    findLastIndexBySameDropOffTimeLimitedAndLocation,
    findLastIndexBySamePickUpTimeLimited,
    findLastIndexBySamePickUpTimeLimitedAndLocation,
    getDropOffControlDelivery,
    getIsDuplicated,
    getPickUpControlDelivery,
    insertControlDelivery,
} from "../../../../utils/delivery/control-delivery";
import {DeliveryState} from "../../../type/delivery-state";

interface Action {
    type: string;
    payload: {
        deliveries: ControlDelivery[];
    };
}

export const addControlDeliveriesDispatch = (
    state: DeliveryState,
    action: Action
) => {
    const {deliveries} = action.payload;

    const splitIndex = state.controlDeliveries.findIndex(
        (controlDelivery) => controlDelivery.type === DeliveryGroupType.Split
    );

    for (const delivery of deliveries) {
        const controlDeliveriesTemp =
            splitIndex === -1
                ? state.controlDeliveries
                : state.controlDeliveries.slice(splitIndex + 1);

        const isDuplicated = getIsDuplicated(state.controlDeliveries, delivery);
        if (!isDuplicated) {
            const pickUpControlDelivery = getPickUpControlDelivery(delivery);
            if (controlDeliveriesTemp.length === 0) {
                controlDeliveriesTemp.push(pickUpControlDelivery);
            } else {
                const lastSamePickUpTimeLimitedAndLocationIndex =
                    findLastIndexBySamePickUpTimeLimitedAndLocation(
                        controlDeliveriesTemp,
                        pickUpControlDelivery
                    );

                if (lastSamePickUpTimeLimitedAndLocationIndex !== -1) {
                    insertControlDelivery(
                        controlDeliveriesTemp,
                        lastSamePickUpTimeLimitedAndLocationIndex + 1,
                        pickUpControlDelivery
                    );
                } else {
                    const lastSamePickUpTimeLimitedIndex =
                        findLastIndexBySamePickUpTimeLimited(
                            controlDeliveriesTemp,
                            pickUpControlDelivery
                        );

                    if (lastSamePickUpTimeLimitedIndex !== -1) {
                        insertControlDelivery(
                            controlDeliveriesTemp,
                            lastSamePickUpTimeLimitedIndex + 1,
                            pickUpControlDelivery
                        );
                    } else {
                        const biggerPickUpTimeLimitedIndex =
                            findIndexByBiggerPickUpTimeLimited(
                                controlDeliveriesTemp,
                                pickUpControlDelivery
                            );

                        if (biggerPickUpTimeLimitedIndex !== -1) {
                            insertControlDelivery(
                                controlDeliveriesTemp,
                                biggerPickUpTimeLimitedIndex,
                                pickUpControlDelivery
                            );
                        } else {
                            controlDeliveriesTemp.push(pickUpControlDelivery);
                        }
                    }
                }
            }

            const dropOffControlDelivery = getDropOffControlDelivery(delivery);
            if (controlDeliveriesTemp.length === 1) {
                controlDeliveriesTemp.push(dropOffControlDelivery);
            } else {
                const lastSameDropOffTimeLimitedAndLocationIndex =
                    findLastIndexBySameDropOffTimeLimitedAndLocation(
                        controlDeliveriesTemp,
                        dropOffControlDelivery
                    );

                if (lastSameDropOffTimeLimitedAndLocationIndex !== -1) {
                    insertControlDelivery(
                        controlDeliveriesTemp,
                        lastSameDropOffTimeLimitedAndLocationIndex + 1,
                        dropOffControlDelivery
                    );
                } else {
                    const lastSameDropOffTimeLimitedIndex =
                        findLastIndexBySameDropOffTimeLimited(
                            controlDeliveriesTemp,
                            dropOffControlDelivery
                        );

                    if (lastSameDropOffTimeLimitedIndex !== -1) {
                        insertControlDelivery(
                            controlDeliveriesTemp,
                            lastSameDropOffTimeLimitedIndex + 1,
                            dropOffControlDelivery
                        );
                    } else {
                        const biggerDropOffTimeLimitedIndex =
                            findIndexByBiggerDropOffTimeLimited(
                                controlDeliveriesTemp,
                                dropOffControlDelivery
                            );

                        if (biggerDropOffTimeLimitedIndex !== -1) {
                            insertControlDelivery(
                                controlDeliveriesTemp,
                                biggerDropOffTimeLimitedIndex,
                                dropOffControlDelivery
                            );
                        } else {
                            controlDeliveriesTemp.push(dropOffControlDelivery);
                        }
                    }
                }
            }
        }

        state.controlDeliveries =
            splitIndex === -1
                ? controlDeliveriesTemp
                : [
                    ...state.controlDeliveries.slice(0, splitIndex + 1),
                    ...controlDeliveriesTemp,
                ];
    }
};
